import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { UsersDataGridPage } from '../../../components/pages/backoffice/users-data-grid-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/users/')({
  component: function Component() {
    return (
      <PermissionChecker
        requiredPermissions={[anyOfPermissions('user.read', 'user.read.relatedOnly', 'user.read.allowedOnly')]}
      >
        <UsersDataGridPage />
      </PermissionChecker>
    )
  },
})
